import { resolve } from 'inversify-react';
import * as React from 'react';
import { RouteComponentProps, Redirect } from 'react-router';
import { Route } from 'react-router-dom';

import { container } from './inversify.config';
import { IdentityService } from './core/services/identity.service';
import ErrorBoundary from 'src/core/ui/error-boundary';


const identity = container.resolve(IdentityService);

export interface ControllerProps<T> extends RouteComponentProps<T> {
	setBusy(isBusy: boolean);
	setLogo?: (logo: string) => void;
}

export class PrivateRoute extends React.Component<any, {}> {
	@resolve
	private readonly identityService: IdentityService;

	render(): React.ReactNode {
		const { component, ...rest } = this.props;
		
		return (
			<Route
				{...rest}
				render={this.renderRoute}
			/>
		);
	}

	private readonly renderRoute = (props: any) => {
		const { component: Component, location, path, ...rest } = this.props;
		if (path === '/login') {
			return null;
		}

		if (this.identityService.isAuthenticated && (rest.permissions == null || this.identityService.isAuthorized(rest.permissions))) {
			
			return (

				<ErrorBoundary>
					<Component
					{...props}
					setBusy={rest.setBusy}
					setLogo={rest.setLogo}
					/>
				</ErrorBoundary>
			);
		}

		const to = {
			pathname: '/login',
			state: { from: location, requirePrivileges: true },
		};

		return (
			<Redirect to={to} />
		);
	}
}



// WEBPACK FOOTER //
// ./src/router.tsx